import React from 'react'
import { Dialog } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import TranslateRoundedIcon from '@mui/icons-material/TranslateRounded'
import { useTranslation } from 'react-i18next'
import { DetailButton } from './detail'
import './detail/detail.css'

interface LanguageSwitchDialogProps {
  open: boolean
  onConfirm: () => void
  onCancel: () => void
}

const LanguageSwitchDialog: React.FC<LanguageSwitchDialogProps> = ({
  open,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation()

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth
      maxWidth="xs"
      PaperProps={{ className: 'incyia-modal-paper' }}
      aria-labelledby="language-switch-dialog-title"
    >
      <div className="incyia-modal-head">
        <div className="incyia-modal-icon" aria-hidden>
          <TranslateRoundedIcon sx={{ fontSize: 22 }} />
        </div>
        <div>
          <h3 id="language-switch-dialog-title">
            {t('frameworkMappingPage.languageSwitchDialog.title')}
          </h3>
          <p>
            {t('frameworkMappingPage.languageSwitchDialog.messageFrench')}
          </p>
        </div>
        <button
          type="button"
          className="incyia-modal-x"
          onClick={onCancel}
          aria-label={t('cancel', { defaultValue: 'Close' })}
        >
          <CloseIcon sx={{ fontSize: 18 }} />
        </button>
      </div>

      <div className="incyia-modal-foot">
        <DetailButton variant="ghost" onClick={onCancel}>
          {t('cancel', { defaultValue: 'Cancel' })}
        </DetailButton>
        <DetailButton onClick={onConfirm}>
          {t('frameworkMappingPage.languageSwitchDialog.confirmButton')}
        </DetailButton>
      </div>
    </Dialog>
  )
}

export default LanguageSwitchDialog
